import { useDataFormStoreApi } from "@/stores/formSave";
import { useDataFormStore } from "@/stores/form";

export default {
  setup() {

    const dataFormApi = useDataFormStoreApi();
    const dataForm = useDataFormStore();

    function openWindow() {
      dataForm.cityDropdown = !dataForm.cityDropdown
      setTimeout(() => {
        document.querySelector('.result-frames__wrapper').setAttribute("style", "min-height: " + ((dataForm.detailsDropdown || dataForm.cityDropdown) ? document.querySelector("[data-frame='2']").offsetHeight+"px" : "75px"));
      }, 500);  
    }

    function showUslugi() {
      // eslint-disable-next-line no-unused-vars
      let uslugi = [
        dataFormApi.cargoDelivery, 
        dataFormApi.cargoPickUp, 
        dataFormApi.cashOnDeliveryAmount, 
        dataFormApi.costForReturningDocuments,
        dataFormApi.costForTheRedemptionOfCargo,
        dataFormApi.costWarranty,
        dataFormApi.extraChargeForCargoDelivery,
        dataFormApi.extraChargeForCargoPickUp,
        dataFormApi.package,
        dataFormApi.transportation,
        dataFormApi.warmPlace
      ];
      
      // Проверяем нулевые ли цены на все услуги?
      let result = Object.values(uslugi).every(x => x === 0);

      return result;
    }

    return {
      openWindow,
      showUslugi,
      dataForm,
      dataFormApi,
    };
  },
};
